import { VirtualItem } from "@tanstack/react-virtual";
import { useRef, useMemo } from "react";
import { usePrevious } from "../../../../hooks/usePrevious";
import { equalRows } from "../helpers/equalRows";


export const useStableVirtualItems = (rows: VirtualItem[]) => {
	const prevRows = usePrevious(rows);
	const rowIdentity = useRef(rows);
	const stableRows = useMemo(() => {
		if (!equalRows(rows, prevRows)) {
			rowIdentity.current = rows;
		}
		return rowIdentity.current;
	}, [rows, prevRows]);
	return stableRows;
};
